__turbopack_context__.v({
  "body": "EditExperienceForm-module-scss-module__t1vigG__body",
  "deleteBtn": "EditExperienceForm-module-scss-module__t1vigG__deleteBtn",
  "row": "EditExperienceForm-module-scss-module__t1vigG__row",
});
